import { Environ, NodeEnvType } from "./types";

let currentEnv: Environ | undefined;

export const setEnv = (env: string | undefined): void => {
  if (!env) return;
  if ((Object.values(Environ) as string[]).includes(env)) {
    currentEnv = env as Environ;
  }
};

const getEnv = (): Environ | undefined => {
  if (process.env.NODE_ENV === NodeEnvType.TEST.toString()) {
    return Environ.TEST;
  }

  return currentEnv;
};

export default getEnv;
